import { useState } from "react";
import { useSelector } from "react-redux";
import { Outlet } from "react-router-dom";
import { selectAuth } from "../../redux/features/auth/auth-slice";
import PublicNavBar from "../../shared/components/public-nav-bar/public-nav-bar";
import logo from "../../shared/oversight-core/assets/images/chloride-logo.png";
import MobileNavBar from "../../shared/oversight-core/shared-components/mobile-nav-bar/mobile-nav-bar";
import SideBar from "../../shared/oversight-core/shared-components/sidebar/side-bar";
import { publicRoutes } from "../routes";
import styles from "./build-system.module.scss";

const BuildSystem = () => {
  const auth = useSelector(selectAuth);

  const [open, setOpen] = useState(false);
  const [collapsed, setCollapsed] = useState(true);

  return (
    <div className="d-flex vh-100">
      {!auth.token && (
        <div
          className={`${styles.sidebar} ${
            collapsed ? styles.sidebarCollapsed : styles.sidebarNotCollapsed
          } d-none d-xl-block`}
        >
          <SideBar
            collapsed={collapsed}
            routes={publicRoutes}
            logos={[logo, logo]}
          />
        </div>
      )}
      <div className="w-100">
        <PublicNavBar
          onMenuClick={() => setCollapsed(!collapsed)}
          onMobileMenuClick={() => setOpen((ps) => !ps)}
        />
        <MobileNavBar
          isOpen={open}
          closeOpen={() => setOpen((ps) => !ps)}
          routes={publicRoutes}
          logos={[logo, logo]}
        />
        <div className={`${styles.outlet}`}>
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default BuildSystem;
